<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div>
  <mat-dialog-content>
    <p-table [value]="complianceAreas"
             [rows]="100"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             selectionMode="single"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             (onRowExpand)="getControlItems($event)"
             dataKey="complianceAreaId"
             #dashboardTable>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header">
          <td colspan="3">
            <a href="#" [pRowToggler]="item">
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              <span>{{item.name}}</span>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-rowData let-columns="columns">
        <p-table [value]="rowData.controlItems"
                 #projectsTable
                 [rows]="100"
                 dataKey="category"
                 exportFilename="projects"
        >

          <ng-template pTemplate="header">
            <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
              <th *ngFor="let col of cols" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}">
                {{col.header}}
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
            <tr class="ui-widget-header"
                *ngIf="rowGroupMetadata[rowData.complianceAreaId][item.category].index === rowIndex">
              <td colspan="3">
                <a href="#" [pRowToggler]="item">
                  <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  <span>{{item.complianceArea.name}} - {{item.category}}</span>
                </a>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
            <tr
              (click)="selectControlItem(item)">
              <td>{{item.category}}</td>
              <td>
                <a (click)="expandedItems[item.controlItemId] = !expandedItems[item.controlItemId];$event.preventDefault();$event.stopPropagation()">
                  <i
                    [ngClass]="expandedItems[item.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </a>
                {{item.complianceAreaControlId}}</td>
              <td>{{item.description}}</td>
            </tr>
            <ng-container *ngIf="expandedItems[item.controlItemId]">
              <tr
                *ngFor="let subitem of item.subItems">
                <td (click)="selectControlItem(subitem)">{{subitem.category}}</td>
                <td (click)="selectControlItem(subitem)">
                  {{subitem.complianceAreaControlId}}</td>
                <td (click)="selectControlItem(subitem)">{{subitem.description}}</td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>

      </ng-template>
    </p-table>
  </mat-dialog-content>
</div>
